import { FC, useContext } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { getAgreementLink, getPolicyLink } from '../shared/TermsLinks';
import { CheckoutServerVarsContext } from '../shared/CheckoutServerVarsContext';

import dibsCss from 'dibs-css';

export const CheckoutRegistrationTerms: FC = () => {
    const { isMobile } = useContext(CheckoutServerVarsContext);
    return (
        <p
            className={classNames(dibsCss.textNoir, dibsCss.sassyFontBodySmall, {
                [dibsCss.ml0]: isMobile,
            })}
        >
            <FormattedMessage
                id="checkout.CheckoutRegistrationTerms.terms"
                defaultMessage="I have read and accepted 1stDibs’ {agreement} and {policy}."
                values={{
                    agreement: getAgreementLink(),
                    policy: getPolicyLink(),
                }}
            />
        </p>
    );
};
